export const closeToasts = (immediate) => {
  const modals = new Set([...document.body.querySelectorAll("#banner-modal")]);
  if (modals.length <= 0) return;
  if (immediate) {
    modals.forEach((el) => el.remove());
    return;
  }
  setTimeout(() => modals.forEach((el) => el.remove()), 5000);
};
